<template>
<div class="chapter">
<div class="inner_page">
<div class="keep">
<p class="imagec"><a id="page_4"></a><a id="page_5"></a><a id="page_6"></a><img alt="image" src="html/images/f0006-01.jpg"/></p>
<h2 class="h2a"><span class="underline">Introduction</span></h2>
<p class="epigraph">Time flies! It has been six years since we last updated <em>The New Appliqué Sampler</em>, and the time has come to make changes and add more information. Although our techniques have not changed significantly over the years, we have more techniques and tips to share with you. You can even watch demonstrations of some of the techniques on our website, <a href="http://www.pieceocake.com" target="_blank">www.pieceocake.com</a>. Whether you are new to appliqué or are very familiar with our techniques, this book is for you. Happy stitching!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781607054726_04_int.vue?4670f2c6